import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Switch from "@material-ui/core/Switch";
import Select from "react-dropdown-select";

import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
  getSelectedBrokerage,
} from "../../store/brokerages";

const PaymentDetails = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  const brokerages = useSelector(getBrokeragesList);
  const selectBorkerage = useSelector(getSelectedBrokerage);

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          //   marginBottom: "20px",
          marginTop: "30px",
        }}
      >
        <div style={{ width: "80%" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color="#f6a07c"
            searchable={true}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "40px",
              fontSize: "1rem",
              borderRadius: 5,
              fontFamily: "GibsonRegular",
              backgroundColor: "#fff",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              border: "none",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"200px"}
          />
        </div>
      </div>
      <PaymentDetailsPane></PaymentDetailsPane>
    </div>
  );
};

const PaymentDetailsPane = () => {
  const commercialQuotingConfigurations = [
    "12 Equals - 30 day funding",
    "17 and 10 - 30 day funding",
    "20 and 9 - 30 day funding",
  ];

  const personalQuotingConfigurations = [
    "Personal Lines - 17 and 10",
    "Personal Lines - 20 and 9",
  ];

  const mgaData = [{ code: "G00120", name: "GROUPASSUR" }];

  const carrierData = [
    { code: "C00625", name: "Northbridge Insurance" },
    { code: "C00653", name: "Intact Insurance" },
    { code: "C01053", name: "Lloyds of London" },
  ];

  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
        marginBottom: "50vh",
        backgroundColor: "#fff",
        padding: "2rem",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={sectionStyle}>
        <h2 style={headingStyle}>Entity Code: A00390</h2>
        <h3 style={subHeadingStyle}>
          Commercial Rate Chart: Quebec Standard-Commercial
        </h3>
        <h3 style={subHeadingStyle}>
          Personal Rate Chart: Quebec Personal Standard
        </h3>
      </div>

      <div style={sectionStyle}>
        <h3 style={subHeadingStyle}>Commercial Quoting Configurations:</h3>
        <ul style={listStyle}>
          {commercialQuotingConfigurations.map((config, index) => (
            <li key={index} style={listItemStyle}>
              {config}
            </li>
          ))}
        </ul>
      </div>

      <div style={sectionStyle}>
        <h3 style={subHeadingStyle}>Personal Quoting Configurations:</h3>
        <ul style={listStyle}>
          {personalQuotingConfigurations.map((config, index) => (
            <li key={index} style={listItemStyle}>
              {config}
            </li>
          ))}
        </ul>
      </div>

      <div style={sectionStyle}>
        <h3 style={subHeadingStyle}>Commercial Fee Plan: 0.40%</h3>
        <h3 style={subHeadingStyle}>Personal Fee Plan: 0.00% - Personal</h3>
      </div>

      <div style={sectionStyle}>
        <h3 style={subHeadingStyle}>MGA:</h3>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Code</th>
              <th style={tableHeaderStyle}>Name</th>
            </tr>
          </thead>
          <tbody>
            {mgaData.map((mga, index) => (
              <tr key={index}>
                <td style={tableDataStyle}>{mga.code}</td>
                <td style={tableDataStyle}>{mga.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={sectionStyle}>
        <h3 style={subHeadingStyle}>Carriers:</h3>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Code</th>
              <th style={tableHeaderStyle}>Name</th>
            </tr>
          </thead>
          <tbody>
            {carrierData.map((carrier, index) => (
              <tr key={index}>
                <td style={tableDataStyle}>{carrier.code}</td>
                <td style={tableDataStyle}>{carrier.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const sectionStyle = {
  marginBottom: "1.5rem",
};

const headingStyle = {
  fontSize: "1.5rem",
  fontWeight: "bold",
  color: "#f6a07c",
  marginBottom: "1rem",
};

const subHeadingStyle = {
  fontSize: "1.2rem",
  fontWeight: "bold",
  color: "#f6a07c",
  marginBottom: "1rem",
};

const listStyle = {
  listStyleType: "none",
  margin: 0,
  padding: 0,
};

const listItemStyle = {
  fontSize: "1.1rem",
  color: "#333",
  marginBottom: "0.5rem",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const tableHeaderStyle = {
  fontSize: "1rem",
  fontWeight: "bold",
  color: "#f6a07c",
  padding: "0.5rem 1rem",
  borderBottom: "1px solid #f6a07c",
};

const tableDataStyle = {
  fontSize: "0.9rem",
  padding: "0.5rem 1rem",
  borderBottom: "1px solid #f6a07c",
};

export default PaymentDetails;
